import { render, staticRenderFns } from "./messageDeliveryResultList.vue?vue&type=template&id=6281cb92"
import script from "./messageDeliveryResultList.vue?vue&type=script&lang=js"
export * from "./messageDeliveryResultList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports